import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useGetApp from "src/hooks/useGetApp";
import useLocales from "src/hooks/useLocales";
import { AppConfigType } from "src/types/apps";

import Context from "../../context";
import useSaveAppConfig from "../../services/useSaveAppConfig";

// ----------------------------------------------------------------------

export const FooterBtn = () => {
	const { state } = useContext(Context);

	const queryClient = useQueryClient();
	const app = useGetApp();
	const { translate } = useLocales();

	const appConfig: AppConfigType = queryClient.getQueryData([app?.id ?? "", "config"])!;

	const { onChangeAppConfig, isLoading } = useSaveAppConfig();

	const disabled =
		state.selectedConfig === appConfig?.entityStatus ||
		state.selectedConfig === appConfig?.selectionMode ||
		(state.selectedConfig === "CUSTOM" && state.entitiesSelected.length === 0);

	return (
		<Stack sx={{ mt: 3, flexDirection: "row", justifyContent: "flex-end" }}>
			<LoadingButton
				variant='contained'
				disabled={disabled}
				loading={isLoading}
				onClick={onChangeAppConfig}
			>
				{translate("app_config.save")}
			</LoadingButton>
		</Stack>
	);
};

export default FooterBtn;
